import { Injectable } from '@angular/core';
import { ToastrManager } from '@niceltd/cxone-components/toastr';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor(
        private toastrManager: ToastrManager
    ) {
        window['_signalRConnection'].client.receiveNotification = (notification) => {
            this.toastrManager.showToaster(
                this.getNotificationType(notification),
                notification.Title, // Our title for their message string. ShortBody is our normal message that we may want to put in here at some point.
                "",
                false, //is System Message
            );
        };
    }

    getNotificationType(notification): 'error'|'success'|'info'|'warning' {
        const sourceLowercase: string = notification?.NotificationSource?.toLowerCase();

        if (sourceLowercase.includes('failed'))
            return 'error';
        if (sourceLowercase.includes('success'))
            return 'success';
        if (sourceLowercase.includes('warning'))
            return 'warning';

        return 'info';
    }
}
